module.exports = __webpack_public_path__ + "static/media/USSDLogo.3d346055.svg";